<template>
    <div class="container-main">
        <keep-alive>
            <router-view :key="key" v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive" :key="key"></router-view>
    </div>

</template>

<script>
export default {
    name: 'index',
    computed: {
        key() {
            return this.$route.path
        },
    }
}
</script>

<style scoped>
.container-main {
    width: 1920px;
    min-width: 960px;
    color: #000000;
}
</style>



// WEBPACK FOOTER //
// src/layout/ContainerMain/index.vue